import { render, staticRenderFns } from "./alipayLogin.vue?vue&type=template&id=06777304"
import script from "./alipayLogin.vue?vue&type=script&lang=js"
export * from "./alipayLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports